<section class="mb-13 mb-md-14">
    <app-hero-image src="assets/images/partner-salons/hero.jpg" />
</section>

<section class="mb-10 mb-md-12">
    <app-title title="PARTNER_SALONS.page_title" subtitle="PARTNER_SALONS.page_description" />
</section>

<section class="mb-13 mb-md-14">
    <app-partners-salons [voivodeship]="voivodeship" />
</section>
